export default __webpack_public_path__ + "static/hero-5c4fb0a386dae66c1e529bc1b9c6f333.gif";